/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

pageTitleStyles.brandGridItem = {
    width: 0,
};

pageTitleStyles.titleText = {
    variant: "h2",
    as: 'h1',
    lineHeight: "34px",
    color: "secondary.main",
    css: css`
        margin-bottom: 22px;
    `,
};

(pageTitleStyles as any).previousPurchaseGridItem = {
    width: 12,
};

(pageTitleStyles as any).previousPurchase = {
    css: css`
        &&& {
            border-radius: 14px;
            background: ${getColor("common.ui25")};
            color: ${getColor("text.inverse")};
            font-size: 10px;
            line-height: 16px;
            font-weight: 700;
            padding: 3px 20px;
        }
    `,
};
